<template>
  <div>
    <v-autocomplete
      :box="!solo"
      :solo="solo"
      :loading="loading"
      v-model="selected"
      clearable
      :items="items"
      :label="label"
      :multiple="multiple"
      item-text="text"
      item-value="value"
      @input="onSelected"
      :rules="required ? [rules.required] : []"
      :required="required"
    ></v-autocomplete>
  </div>
</template>

<script>
import apiCtrl from '@/services/aru-services/aru-api.service.js';

export default {
  props: {
    value: [Number, String, Array],
    required: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    solo: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Cliente',
    },
  },
  data() {
    return {
      items: [],
      loading: false,
      selected: this.value ? this.value : null,
      rules: {
        required: value => !!value || 'Este campo es obligatorio.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Email inválido';
        },
      },
    };
  },

  mounted() {
    this.getEntities();
  },
  methods: {
    async getEntities() {
      this.loading = true;
      this.$emit('loading');
      const res = await apiCtrl.get('/admin/aplifisa/fiscal/input-select');

      this.items = res.data;

      this.loading = false;
    },
    onSelected() {
      this.$emit('input', this.selected);
    },
  },
  watch: {
    // El valor puede cambiar desde fuera (p. ej. al aplicar un filtro guardado)
    value(val) {
      this.selected = val ? val : null;
    },
  },
};
</script>

<style></style>
